import {Component, OnInit} from '@angular/core';
import {FacadeService} from "../../shared/service-facade/facade.service";
import {SignupService} from "../service/signup.service";
import {NGXLogger} from "ngx-logger";
import {ValidationDetail} from "../../shared/model/ValidationDetail";
import {FormArray, FormControl, FormGroup, ValidationErrors} from "@angular/forms";

@Component({
  selector: 'app-validation',
  templateUrl: './validation.component.html',
  styleUrls: ['./validation.component.css']
})
export class ValidationComponent implements OnInit {
  controlsAndErrors: Map<string, string> = new Map();
  get errors(): Array<string> {
    return Array.from(this.controlsAndErrors.values());
  }

  constructor(private facadeService: FacadeService,
              private signupService: SignupService,
              private logger: NGXLogger,
  ) {
  }

  /**
   * Init the component.
   */
  ngOnInit(): void {
    this.signupService.validationsChange.subscribe(validationDetail => {
      this.validateAllFormControl(validationDetail);
    })
  }

  /**
   * Validate all form controls
   * @param formGroup Form group to validate.
   */
  validateAllFormControl(validationDetail: ValidationDetail) {
    //this.errors = [];
    Object.keys(validationDetail.formGroup.controls).forEach(field => {
      const control = validationDetail.formGroup.get(field)!;

      if (control instanceof FormControl) {
        if (!control.touched) {
          return;
        }

        const { id } = control.parent?.value;
        const fieldIdentifier = field + id;
        if (!control.errors || validationDetail.reset) {
          this.controlsAndErrors.delete(fieldIdentifier);
          return;
        }

        let message: string | undefined;

        if (control.errors.message) {
          message = control.errors.message;
        } else {
          message = validationDetail.labels.get(field);
        }

        if (message) {
          this.controlsAndErrors.set(fieldIdentifier, message);
        }

        return;
      }

      if (control instanceof FormGroup) {
        this.validateAllFormControl(new ValidationDetail(control, validationDetail.labels));

        return;
      }

      if (control instanceof FormArray) {
        // Clean possible errors
        Array.from(validationDetail.labels.keys()).forEach(field => {
          this.controlsAndErrors.delete(field);
        });

        const errors = validationDetail.formGroup.errors;
        if (!errors) {
          return;
        }

        // Set labels for form errors
        Object.keys(errors).forEach(field => {
          this.controlsAndErrors.set(field, validationDetail.labels.get(field)!);
        });

        return;
      }

    });
  }
}
